import React, { useEffect, useRef, useState } from 'react';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import { Link } from 'react-router-dom';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { useSelector } from 'react-redux';
import Button from '../Button';

function AddendumPopup({ soapId = '', hanleClose = () => {}, handleReload }) {
  const { user } = useSelector((state) => state.auth);
  const inputRef = useRef(null);
  const [allData, setAllData] = useState(false);
  const [tempListDd, setTempListDd] = useState(false);
  const [proTemoList, setProTemoList] = useState([]);
  const [text, setText] = useState('');
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [proReasonTempList, setproReasonTempList] = useState([]);
  const [reasonText, setReasonText] = useState('');
  const [reasonTempListDd, setReasonTempListDd] = useState(false);
  const reasonInputRef = useRef(null);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/openAddendumPopup',
          {
            soapId: soapId,
            loginUserId: user?.id,
            userType: user?.type,
          }
        );
        if (response.status === 200) {
          setAllData(response.data);
          setProTemoList(
            response.data?.getProviderAdditionalTemplatesList || []
          );
          setproReasonTempList(
            response.data?.getProviderReasonTemplatesList || []
          );
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [soapId, user?.id, user?.type]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef?.current.contains(event.target)) {
        setTempListDd(true);
      } else {
        setTempListDd(false);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [inputRef]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        reasonInputRef?.current &&
        !reasonInputRef?.current.contains(event.target)
      ) {
        setReasonTempListDd(true);
      } else {
        setReasonTempListDd(false);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [reasonInputRef]);

  const handleTextToEdit = (id) => {
    const elmnt = proTemoList.find((item) => item?.id === id);
    let textData =
      text === ''
        ? elmnt?.template_detail
        : text + '\n' + elmnt?.template_detail;
    setText(textData);
    setTempListDd(false);
  };

  const handleReasonTextToEdit = (id) => {
    const elmnt = proReasonTempList.find((item) => item?.id === id);
    let textData =
      reasonText === ''
        ? elmnt?.template_detail
        : reasonText + '\n' + elmnt?.template_detail;
    setReasonText(textData);
    setReasonTempListDd(false);
  };

  const handleAddendumSave = () => {
    (async () => {
      try {
        if (!reasonText) {
          setUiMessage('err', 'Please write Reason for Addendum.');
          return;
        } else if (!text) {
          setUiMessage('err', 'Please write some Additional Information.');
          return;
        }
        const response = await post('api/patient/progressNote/handleAddendum', {
          soapId: soapId,
          addendumTextArea: text,
          addendumReasonTextArea: reasonText,
          loginUserId: user?.id,
          id: '',
        });
        if (response.status === 200) {
          if (response.data?.msg === 'success') {
            setUiMessage('suc', 'Save successfully');
            handleReload(''); //addendum
            response.data?.addendumList &&
              setAllData({
                ...allData,
                addendumList: response.data?.addendumList,
              });
            setText('');
            setReasonText('');
          } else {
            setUiMessage('err', response.data?.msg);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const getSpecificAddendumData = (id) => {
    const elmnt = allData?.addendumList.find((item) => item?.id === id);
    setText(elmnt?.description);
    setReasonText(elmnt?.reason);
    setEdit(id);
  };

  const handleCancle = () => {
    setText('');
    setReasonText('');
    setEdit(false);
  };
  const handleAddendumUpdate = (id) => {
    (async () => {
      try {
        if (!reasonText) {
          setUiMessage('err', 'Please write Reason for Addendum.');
          return;
        } else if (!text) {
          setUiMessage('err', 'Please write some Additional Information.');
          return;
        }
        const response = await post('api/patient/progressNote/handleAddendum', {
          soapId: soapId,
          addendumTextArea: text,
          addendumReasonTextArea: reasonText,
          loginUserId: user?.id,
          id: id,
        });
        if (response.status === 200) {
          if (response.data?.msg === 'success') {
            setUiMessage('suc', 'Update successfully');
            handleReload('addendum');
            response.data?.addendumList &&
              setAllData({
                ...allData,
                addendumList: response.data?.addendumList,
              });
            setText('');
            setReasonText('');
            setEdit(false);
          } else {
            setUiMessage('err', response.data?.msg);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const confirmDelete = (id) => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/handleAddendumDelete',
          {
            soapId: soapId,
            loginUserId: user?.id,
            id: id,
          }
        );
        if (response.status === 200) {
          if (response.data?.msg === 'success') {
            setUiMessage('suc', 'Delete successfully');
            handleReload('addendum');
            response.data?.addendumList &&
              setAllData({
                ...allData,
                addendumList: response.data?.addendumList,
              });
          } else {
            setUiMessage('err', response.data?.msg);
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  return (
    <div className="modalBackground">
      <div className="addendum-main-con">
        <div className="edit-nurse-note-header border0 width100">
          <span className="body-header-text">Addendum</span>
          <Button variant="circle" onClick={hanleClose}>
            X
          </Button>
        </div>
        <div class="left width100 hide">
          <div className="left width50prcnt">
            <div className="addendum-info-container">
              <label
                className="instruction-form-lable"
                style={{ width: '150px' }}
              >
                Addendum Date & Time:
              </label>
              <span className="addendumvalue">
                {allData?.addenData && allData?.addenData[0]?.addenDateTime}
              </span>
            </div>
            <div className="addendum-info-container">
              <label
                className="instruction-form-lable"
                style={{ width: '150px' }}
              >
                Added By:
              </label>
              <span className="addendumvalue">
                {allData?.addenData && allData?.addenData[0]?.addedBy}
              </span>
            </div>
          </div>
          <div className="left width50prcnt">
            <div className="addendum-info-container">
              <label className="instruction-form-lable">
                Provider Name & Credentials:
              </label>
              <span className="addendumvalue">
                {allData?.addenData && allData?.addenData[0]?.providerDetail}
              </span>
            </div>
            <div className="addendum-info-container">
              <label className="instruction-form-lable">
                Original Note Date:
              </label>
              <span className="addendumvalue">
                {allData?.addenData && allData?.addenData[0]?.originalDate}
              </span>
            </div>
          </div>
        </div>
        <div className="addendum-con-bdy">
          <div className="addendum-con-bdy-lft">
            <div className="nurse-note-edit-upper-container form-bg-color alert-wdgt width100">
              <div className="left addendum-frm-hdr width100">
                Reason for Addendum:
              </div>

              <div className="nurse-edit-container-data-row clear-bottom5 width100">
                <div className="data-row-text-value width100">
                  <textarea
                    placeholder="You can write here.."
                    className="complain-comment-input-box color-text"
                    value={reasonText}
                    style={{
                      qheight: '200px',
                      qwidth: '100%',
                    }}
                    onChange={(e) => setReasonText(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="left addendum-frm-hdr width100">
                Additional Information:
              </div>

              <div className="nurse-edit-container-data-row clear-bottom5 width100">
                <div className="data-row-text-value width100">
                  <textarea
                    placeholder="You can write here.."
                    className="complain-comment-input-box color-text"
                    value={text}
                    style={{
                      qheight: '200px',
                      qwidth: '100%',
                    }}
                    onChange={(e) => setText(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div
                className="nurse-edit-container-data-row width100"
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  paddingBottom: '5px',
                }}
              >
                {edit ? (
                  <>
                    <span
                      className="right clear-right clear-bottom5"
                      onClick={() => handleCancle()}
                    >
                      <div className="actn-No qbutton-cancel">Cancel</div>
                    </span>
                    <span
                      className="right clear-right clear-bottom5"
                      onClick={() => handleAddendumUpdate(edit)}
                    >
                      <div className="qbutton-submit actn-yes">Update</div>
                    </span>
                  </>
                ) : (
                  <span className="clear-right clear-bottom5">
                    <div
                      className="qbutton-submit actn-yes"
                      onClick={handleAddendumSave}
                    >
                      Record
                    </div>
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="addendum-con-bdy-rt">
            {allData?.addendumList &&
            allData?.addendumList.length > 0 &&
            allData?.addendumList ? (
              <>
                {allData?.addendumList.map((item, i) => {
                  return (
                    <div className="nurse-note-popup-lower-block width100 content-line-break">
                      <div
                        key={item?.id}
                        className="data-row-text-value"
                        id="noteText"
                        style={{
                          width: 'calc(100% - 20px)',
                          lineHeight: '21px',
                        }}
                      >
                        <span className="left width100">
                          <span className="left width100">
                            <span className="left" style={{ width: '78%' }}>
                              <b>Provider name & credentials: </b>{' '}
                              {item?.ProviderDetail} <br />
                              <b>Original note: </b> {item?.originalNote} <br />
                              <b>Addendum: </b> {item?.addendumDate} <br />
                              <b>Added by: </b> {item?.addedBy} <br />
                            </span>
                            <span className="left" style={{ width: '22%' }}>
                              <div className="left clear5 width100">
                                <span className="nurse-note-edit-popup margin0">
                                  <span
                                    onClick={() =>
                                      getSpecificAddendumData(item?.id)
                                    }
                                  >
                                    <Link>[ Change</Link>
                                  </span>{' '}
                                  |{' '}
                                  <span
                                    onClick={() => {
                                      handleCancle();
                                      setDeleteId(item?.id);
                                    }}
                                  >
                                    <Link>Delete ]</Link>
                                  </span>
                                </span>
                              </div>
                            </span>
                          </span>
                          <span className="left width100">
                            <b>Reason of Addendum: </b>
                            <br />
                            <span
                              dangerouslySetInnerHTML={{ __html: item?.reason }}
                            />{' '}
                            <br />
                            <b>Additional Information: </b>
                            <br />{' '}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            />
                          </span>
                        </span>
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="addendum-con-bdy-notfoumd">No record found</div>
            )}
          </div>
        </div>
        <div className="nurse-note-btn-row width100">
          <span className="right clear-right">
            <span className="qbutton-cancel actn-No right" onClick={hanleClose}>
              Close
            </span>
          </span>
        </div>
      </div>
      {deleteId && (
        <ConfirmDialog
          bodytext="Are you sure..! want to delete this record ?"
          closeDialog={() => setDeleteId(false)}
          successDialog={(id) => confirmDelete(id)}
          sucPrams={deleteId}
        />
      )}
    </div>
  );
}

export default AddendumPopup;
